import React from "react";
import { rem, Text } from "@mantine/core";

export const WidgetTitle = ({ children, ...rest }) => {
  return (
    <Text fw="bold" fz={rem(20)} {...rest}>
      {children}
    </Text>
  );
};
